import { z } from 'zod';

export const TransferCallToolName = 'transferCall' as const;

/**
 * Live call hand-off to a human operator. Voice-only: the tool is
 * implemented in `apps/voice-api` (it needs the live call), so unlike every
 * other built-in it is not present in shared-backend's built-in tool map and
 * is never resolved by `resolveToolsForChat` — the voice run context appends
 * it when `voiceConfig.operatorTransfer.enabled` is set.
 */
export const transferCallArgsSchema = z.object({
  reason: z
    .string()
    .describe(
      'Why the caller needs a human — used for the hand-off log, not spoken to the caller.',
    ),
  operatorId: z
    .string()
    .optional()
    .describe(
      'id of the best-fitting operator, taken from the AVAILABLE OPERATORS list in the system prompt. Omit if no operator clearly fits.',
    ),
});

export type TransferCallArgs = z.infer<typeof transferCallArgsSchema>;

export const EndCallToolName = 'endCall' as const;

/**
 * Lets the agent hang up a live call on its own initiative once the
 * conversation is genuinely over, instead of saying goodbye and then sitting
 * on an open line until the caller manually hangs up. Voice-only, for the
 * same reason `transferCall` is: it needs the live call, so it lives in
 * `apps/voice-api` rather than shared-backend's built-in tool map.
 */
export const endCallArgsSchema = z.object({
  reason: z
    .string()
    .describe(
      'Why the call is ending — used for the call log, not spoken to the caller.',
    ),
});

export type EndCallArgs = z.infer<typeof endCallArgsSchema>;
